import { Suspense, lazy, useEffect, useState } from "react";
import { Button, Table, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { GetAllThumbnails, deleteThumbnail, saveThumbnail, updateThumbnail } from "../../../services/CommonService";
import FileBase64 from 'react-file-base64';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Accordion } from "react-bootstrap";


const Thumbnail = ({ updateprops }) => {
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ size: [] }],
            [{ font: [] }],
            [{ align: ["right", "center", "justify"] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            [{ color: ["red", "#785412"] }],
            [{ background: ["red", "#785412"] }]
        ]
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "link",
        "color",
        "image",
        "background",
        "align",
        "size",
        "font"
    ];
    const [percent, setPercent] = useState(50);
    const [value, setValue] = useState('');

    const fields = {
        position: '',
        status: '',
        videourl: '',
        toplevelprogramid: updateprops.id,
        description: ''
    }
    const errors = {
        position: '',
        status: '',
        videourl: '',
    }
    const [formfields, setFromFields] = useState(fields);
    const [errorFields, setErrorFields] = useState(errors);
    const { position, videourl, status } = formfields;
    const [sectionlist, setSectionList] = useState([]);
    const [postModal, setPostModal] = useState(false);
    const [filefields, setFileFields] = useState(null);
    const [imageshow, setImageShow] = useState(false);
    const [mobilefields, setMobileFields] = useState(null);
    const [mblimageshow, setMblImageShow] = useState(false);


    function handleChangeFile(files) {
        setFileFields(files[0]);
        if (files[0].type === 'image/png' || files[0].type === 'image/jpeg' || files[0].type === 'image/jpg') {
            let sz = files[0].size.split(' ');
            if (sz[0] > 200) {
                toast('File size should be below 200 kb', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setFileFields(files[0].base64);
                //setImageShow(files[0].base64);
                setImageShow(true);
            }
        } else {
            toast('Please upload only png or jpg', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        //setFile(event.target.files[0])
    }

    function handleChangeFile1(files) {
        setMobileFields(files[0]);
        if (files[0].type === 'image/png' || files[0].type === 'image/jpeg' || files[0].type === 'image/jpg') {
            let sz = files[0].size.split(' ');
            if (sz[0] > 200) {
                toast('File size should be below 200 kb', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setMobileFields(files[0].base64);
                //setImageShow(files[0].base64);
                setMblImageShow(true);
            }
        } else {
            toast('Please upload only png or jpg', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        //setFile(event.target.files[0])
    }

    const handleProcedureContentChange = (content, delta, source, editor) => {
        setValue(content);
    };
    const [subadminbar, setSubAdminbar] = useState(true);


    useEffect(() => {
        getAllThumbnails();
        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        console.log("constuserdetails", constuserdetails.roles[0]);
        if (constuserdetails?.roles[0] == 'ROLE_SUBADMIN') {
            setSubAdminbar(false)
        }
    }, []);

    const getAllThumbnails = async () => {

        const reqdata = {
            pageno: '-1',
            query: { toplevelprogramid: updateprops.id }
        }

        const Response = await GetAllThumbnails(reqdata);
        setSectionList(Response.data);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }

    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;

        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status .";
        }



        setErrorFields(errors)
        return formIsValid;

    }

    const submitForm = async () => {
        const isValid = await validateForm();
        if (isValid) {
            formfields.image = filefields;
            formfields.description = value;
            formfields.mobileimage=mobilefields;

            if (!formfields.id) {
                //save
                const Response = await saveThumbnail(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    getAllThumbnails();
                    setFromFields(fields);
                    setImageShow(false)
                    setValue('')
                }

            } else {
                //update
                const Response = await updateThumbnail(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    getAllThumbnails();
                }
            }
        }
    }

    const deleteRecord = async (item) => {
        const Response = await deleteThumbnail(item);
        if (Response.data.id) {
            notifyTopFullWidth("Data deleted successfully");
            getAllThumbnails();
        }
    }

    const updateRecord = async (item) => {
        // console.log("item", item);
        setFromFields(item);
        setFileFields(item.image)
        setImageShow(true)
        setValue(item.description)
        setMblImageShow(true)
        setMobileFields(item.mobileimage)
    }


    const closemodal = async () => {
        setPostModal(false);
    }
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="row">
                <div className="form-group mb-3 col-md-3">
                    <label>Position</label>
                    <input component="input"
                        placeholder="position"
                        name="position"
                        className="form-control"
                        value={position} maxLength={50} onChange={handleChange} />

                    <div className="errorMsg">{errorFields.position}</div>
                </div>
                <div className="form-group mb-3 col-md-3">
                    <label>Video URL</label>
                    <input component="input"
                        placeholder="video url"
                        name="videourl"
                        className="form-control"
                        value={videourl} maxLength={500} onChange={handleChange} />
                </div>
                <div className="form-group mb-3 col-md-3">
                    <label>Status</label>
                    <select
                        className="form-control" name='status'
                        onChange={handleChange} value={status}>
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>
                    <div className="errorMsg">{errorFields.status}</div>
                </div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                   Web Image
                </label>
                <div className="custom-file">
                    <FileBase64
                        multiple={true}
                        onDone={handleChangeFile} />
                </div>
            </div>

            {imageshow && <> <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Uploaded Image
                </label>
                <img src={filefields} alt="Red dot" />

            </div> </>}

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                   Mobile Image
                </label>
                <div className="custom-file">
                    <FileBase64
                        multiple={true}
                        onDone={handleChangeFile1} />
                </div>
            </div>

            {mblimageshow && <> <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Uploaded Image
                </label>
                <img src={mobilefields} alt="Red dot" />

            </div> </>}

            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                        Add Description
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                            <ReactQuill
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                value={value}
                                onChange={handleProcedureContentChange}
                            />
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>
            </Accordion>


            <div className="form-group mb-3 col-md-3">
                <Button onClick={submitForm} className="me-2" variant="info">
                    Save Thumbnail
                </Button>

            </div>




            <Table responsive>
                <thead>
                    <tr>
                        <th className="width80">
                            <strong>Position</strong>
                        </th>
                        <th>
                            <strong>Image</strong>
                        </th>
                        <th>
                            <strong>Video URL</strong>
                        </th>
                        <th>status</th>
                    </tr>
                </thead>
                <tbody>
                    {sectionlist?.map(item => (
                        <tr>
                            <td>
                                <strong>{item.position}</strong>
                            </td>
                            <td>{item.videourl}</td>
                            <td>{item.status}</td>
                            <td>
                                <Button onClick={() => updateRecord(item)} className="me-2"
                                    variant="info">
                                    Update
                                </Button>

                                {subadminbar && <Button onClick={() => deleteRecord(item)} className="me-2" variant="danger">
                                    Delete
                                </Button>}



                            </td>


                        </tr>
                    ))}

                </tbody>
            </Table>


        </>)

}

export default Thumbnail

